import script from "./Auth.vue?vue&type=script&lang=ts&setup=true"
export * from "./Auth.vue?vue&type=script&lang=ts&setup=true"

import "./Auth.vue?vue&type=style&index=0&id=78b68864&lang=less"

const __exports__ = script;

export default __exports__